var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "64px",
    width: "64px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-56.32 -56.32 624.64 624.64",
    xmlSpace: "preserve",
    fill: "#24352F",
    stroke: "#24352F",
    strokeWidth: 6.656000000000001,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 1.024
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3E9E0"
    },
    d: "M9.694,468.335L256,30.865l246.306,437.47H9.694z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#24352F"
    },
    d: "M243.2,140.8v204.8c0,7.074,5.726,12.8,12.8,12.8c7.074,0,12.8-5.726,12.8-12.8V140.8 c0-7.074-5.726-12.8-12.8-12.8C248.926,128,243.2,133.726,243.2,140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#24352F"
    },
    d: "M508.57,442.735L278.17,43.674c-4.574-7.919-13.022-12.8-22.17-12.8 c-9.148,0-17.596,4.881-22.17,12.8L3.43,442.735c-4.574,7.919-4.574,17.681,0,25.6s13.022,12.8,22.17,12.8h460.8 c9.148,0,17.596-4.881,22.17-12.8C513.143,460.416,513.143,450.654,508.57,442.735z M25.6,455.535L256,56.474l230.4,399.061H25.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#24352F"
    },
    cx: 256,
    cy: 409.6,
    r: 25.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningError);
export default __webpack_public_path__ + "static/media/warning-error.30893e92.svg";
export { ForwardRef as ReactComponent };